import { IChangeFlag } from 'src/interfaces/IChangeFlag';
import { INewHireException } from 'src/interfaces';
import http from './http';

class NewHireExceptionService {
  static create(data: INewHireException) {
    return http.post('/new-hire-exception', data);
  }

  static change(data: IChangeFlag) {
    return http.patch('/new-hire-exception', data);
  }

  static getNewHireRange(employeeId: string) {
    return http.get(`/new-hire-exception/range/${employeeId}`);
  }

  static getHirtoric(employeeId: string) {
    return http.get(`/new-hire-exception/historic?employeeId=${employeeId}`);
  }

  static deleteHirtoric(exceptionId: string) {
    return http.delete(`/new-hire-exception/${exceptionId}`);
  }
}
export default NewHireExceptionService;
